import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ext" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["file-icon", {pulse: $props.pulse, painted: $props.painted}]),
    relative: ""
  }, [
    ($props.painted)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          width: $props.width,
          height: $props.height,
          asset: "page"
        }, null, 8 /* PROPS */, ["width", "height"]))
      : (_openBlock(), _createBlock(_component_Icon, {
          key: 1,
          width: $props.width,
          height: $props.height,
          class: "svg-icon",
          icon: "file"
        }, null, 8 /* PROPS */, ["width", "height"])),
    _createElementVNode("div", _hoisted_1, _toDisplayString($props.ext), 1 /* TEXT */)
  ], 2 /* CLASS */))
}